<template>
  <NavView></NavView>
    <SideBar></SideBar>
<div class="container-fluid mb-5" >
    <!-- <h4 class="manage-boder">Manage Customer</h4>  -->

    <h6 class="manage-boder pt-2 font1 font-bold1">
         <router-link class="decoration" to="/user-management/auth-item-group/index"> Permission groups </router-link>
         <span class="pfimg1"><i class="fa fa-angle-right" aria-hidden="true"></i></span>
         Editing
    </h6>
    
   
   

<div class="card ">
  <div class="card-body">
    
 



<Table id=""  class="table table-borderless table-sm w-75 p-3 font1">
  <tbody>
    <tr>
    <td class="align-right font1">Name</td>
    <td> <input class="form-control font1 w-75" type="password"> </td>
    </tr>

    <tr>
    <td class="align-right">Code</td>
    <td ><input class="form-control font1 w-75" type="password"></td>
    </tr>

   
   

    
  </tbody>
 
    
 
  
</Table>


<div class="right1 mt-4">
                       
                    
    <div class="d-grid gap-2 d-md-flex justify-content-md-end mb-5">
    
        <button   class="btn1 btn btn-success" type="submit"> Update</button>
        <router-link class="line1 btn btn-danger " to="/user-management/auth-item-group/index">Cancel</router-link>
    </div>
</div>

</div>
</div>


</div>
<!-- <button v-on:click="loadData1()" type="" class="btn btn-danger" >press</button> -->
<!-- <form @submit.prevent="del()" class="" >
 <input type="text" v-model="user.id"  class="form-control" >
 <button  type="" class="btn btn-success" >delete</button>
 </form> -->

</template>

<script>
 //import {   CButton, } from '@coreui/vue';
 //import httpClient from '@/axios';
 import axios from 'axios';
 import authService from '@/auth.service';
 import NavView from '../../NavView.vue'
  import SideBar from '../../SideBar.vue'



export default {
    components:{ 
      NavView,SideBar
    },

    mounted(){
  this.loadIgrn()
    },
   

    data(){
    return{
      
        igrns:'',
      access_token:authService.isLoggedIn(),
     
     
        

      
  
     
    };
    },


   methods:{ 



    viewload(id) {
   console.log(id); 
   this.$router.push('/igrn/view?data='+id); 
        //this.$refs.table.innerHTML = response.data.success;
        
  } ,

  createLoad(){
    this.$router.push('/spaymentreceipts/create');
  },
  
  viewLoad(){
    this.$router.push('/sinvoice/view');
  },

    async loadIgrn() {
    console.log(this.access_token);
    try {
      const { data} = await  axios.get('/web/api/ig',{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.igrns = data.item_list;
       this.totalItem = Math.ceil((data.totalItems)/10);
    } catch (error) {
      console.log(error.response);
    }
  },
   

  async page(pageid){
  this.$router.push('/igrn/index?page='+pageid); 
  try {
        const { data} = await  axios.get('/web/api/igrn/index?page='+pageid,{
        headers:{
          'Authorization':'Bearer '+this.access_token,
          'Content-type': 'application/json',
         
        }
       });
       console.log(data);
       this.igrns = data.item_list;
       this.totalItem = Math.ceil((data.totalItems)/10);
       



      } catch (error) {
        console.log(error.response);
      }
    
  }, 






}




};

</script>

<style scoped>
.button1{
  width: 10px !important;
}
.border1{
  border: none;
  background-color: #0d6efd;
}
.font-color1:hover{
  color: black !important;
  cursor: pointer;
}
.manage-boder{
  border-bottom: 1px solid #E9E9E3;
  border-top: 1px solid #E9E9E3;
}


.font1{
      font-size: 13px !important;
   
    }
    .font-bold1{
      font-weight: bold;
    }
    .manage-boder{
    border-bottom: 2px solid #E9E9E3;
    border-top: 2px solid #E9E9E3;
    padding-bottom: 10px !important;
    padding-top: 10px !important;
    
    }
    .font1{
      font-size: 13px !important;
   
    }
    .font-bold1{
      font-weight: bold !important;
    }
    .colr1{
        color:#A5A5A3;
        
    }
    .decoration{
    text-decoration: none;
    color:#A5A5A3  ;
  }
  .width7{
    width: 250px;
  }
  .align-right{
    text-align: right !important;
    padding-top: 11px !important;
    padding-right: 20px !important;
  }
  .mt-my{
    margin-top: 2px;
  }
  .btn1 {
        padding-left: 18px;
        padding-right: 18px;
    }
  
 
</style> 